import {
  ChatIcon,
  ChatUnreadIcon,MusicIcon
} from '@100mslive/react-icons';
import {
  selectIsAllowedToPublish,
  // HMSPlaylistType,
  selectUnreadHMSMessagesCount,useHMSStore,
  useScreenShare
} from '@100mslive/react-sdk';
import {Flex,IconButton,Tooltip,VerticalDivider} from '@100mslive/roomkit-react';
import React,{Fragment,useState} from 'react';
import {FeatureFlags} from '../services/100-ms-services/FeatureFlags';
// import {ScreenshareToggle} from './ScreenShare';
// import {ScreenShareHintModal} from './ScreenshareHintModal';
// import {NoiseSuppression} from '../plugins/NoiseSuppression';
// import {ToggleWhiteboard} from '../plugins/whiteboard';
// import {VirtualBackground} from '../plugins/VirtualBackground/VirtualBackground';
// import {useMyMetadata} from './hooks/useMetadata';
// import {FeatureFlags} from '../services/FeatureFlags';
// import {isScreenshareSupported} from '../common/utils';
// import {Playlist} from '../components/Playlist/Playlist';
import {useIsChatOpen,useToggleChat} from './AppData/useChatState';
import {AudioVideoToggle} from './AudioVideoToggle';
import {isScreenshareSupported} from './common/utils';
import {useMyMetadata} from './hooks/useMetadata';
import {LeaveRoom} from './LeaveRoom';
import {MoreSettings} from './MoreSettings/MoreSettings';
import {ScreenshareToggle} from './UI-Components/ScreenShare';
import useWindowDimensions from './windowDimension';

// const TranscriptionButton = React.lazy(
//   () => import('../plugins/transcription')
// );

const ScreenshareAudio = () => {
  const {
    amIScreenSharing,
    screenShareVideoTrackId: video,
    screenShareAudioTrackId: audio,
    toggleScreenShare,
  } = useScreenShare();
  const isAllowedToPublish = useHMSStore(selectIsAllowedToPublish);
  const isAudioScreenshare = amIScreenSharing && !video && !!audio;
  const [showModal, setShowModal] = useState(false);
  if (!isAllowedToPublish.screen || !isScreenshareSupported()) {
    return null;
  }
  return (
    <Fragment>
      <Tooltip
        title={`${!isAudioScreenshare ? 'Start' : 'Stop'} audio sharing`}
        key="shareAudio">
        <IconButton
          active={!isAudioScreenshare}
          css={{mr: '$4'}}
          onClick={() => {
            if (amIScreenSharing) {
              if (toggleScreenShare) {
                toggleScreenShare();
              }
            } else {
              setShowModal(true);
            }
          }}
          data-testid="screenshare_audio">
          <MusicIcon />
        </IconButton>
      </Tooltip>
      {showModal && (
        // <ScreenShareHintModal onClose={() => setShowModal(false)} />
        <></>
      )}
    </Fragment>
  );
};

export const MetaActions = (props:any) => {
  const {isHandRaised, isBRBOn, toggleHandRaise, toggleBRB} = useMyMetadata();

  return (
    <Flex align="center" style={{marginLeft:10}}>
      <Tooltip title={`${isBRBOn ? `I'm back` : `I'll be right back`}`}>
        <div data-testid="brb_btn" onClick={toggleBRB} style={{marginRight:6,display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundImage:isBRBOn?'linear-gradient(255.9deg, #1E9DAE -23.69%, #D478FF 116.28%)': props?.isMobile ? 'linear-gradient(#F2F4F7,#F2F4F7,#F2F4F7)' : 'linear-gradient(white,white,white)',height:36,width:55,borderRadius:100,cursor:'pointer'}}>
          <div style={{fontSize:'14px',color:isBRBOn?'white':'#475467'}}>
            BRB
          </div>
        </div>
      </Tooltip>
      {props?.isMobile && <VerticalDivider space={4} style={{background:'#E4E7EC'}}/>}
      <Tooltip
        title={`${!isHandRaised ? 'Raise' : 'Unraise'} hand`}
      >
        <div data-testid={`${props?.isMobile ? 'raise_hand_btn_mobile' : 'raise_hand_btn'}`} onClick={toggleHandRaise} style={{backgroundImage:isHandRaised?'linear-gradient(255.9deg, #1E9DAE -23.69%, #D478FF 116.28%)': props?.isMobile ? 'linear-gradient(#F2F4F7,#F2F4F7,#F2F4F7)' : 'linear-gradient(white,white,white)',height:36,width:36,borderRadius:100,cursor:'pointer',marginLeft:4,display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
          <img
            src={require('../asset/icons/HandRaiseIcon.png')}
            alt='logo'
            width='20px'
          />
        </div>
      </Tooltip>
    </Flex>
  );
};

const Chat = () => {
  const countUnreadMessages = useHMSStore(selectUnreadHMSMessagesCount);
  const isChatOpen = useIsChatOpen();
  const toggleChat = useToggleChat();

  return (
    <Tooltip key="chat" title={`${isChatOpen ? 'Close' : 'Open'} chat`}>
      <IconButton
        css={{mx: '$4'}}
        onClick={toggleChat}
        active={!isChatOpen}
        data-testid="chat_btn">
        {countUnreadMessages === 0 ? (
          <ChatIcon />
        ) : (
          <ChatUnreadIcon data-testid="chat_unread_btn" />
        )}
      </IconButton>
    </Tooltip>
  );
};



export const Footer = ({meetingUrl,isMobile}: any) => {
  const [fullScreen,setFullScreen]=useState(false)
  const { height, width } = useWindowDimensions();
  const [isIPad] = [height >= 1024 && height <= 1366];
  const switchFullScreen = () => {
    setFullScreen(!fullScreen)
  }
  return (
    <Flex
      justify="between"
      align="center"
      css={{
        padding: '$2',
        position: 'relative',
        height: !isIPad ? '100%' : undefined,
        '@md': {flexWrap: 'wrap'},
      }}>
      <Flex
        align="center"
        css={{
          position: 'absolute',
          left: '$7',
          '@md': {
            position: 'unset',
            justifyContent: 'center',
            w: '100%',
            p: '$4 0',
          },
        }}>
        {/* <ScreenshareAudio /> */}
        {/* <Playlist type={HMSPlaylistType.audio} /> */}
        {/* <Playlist type={HMSPlaylistType.video} /> */}
        {FeatureFlags.enableWhiteboard ? (
          // <ToggleWhiteboard />
          <></>
        ) : null}
        {/* <LeftDivider /> */}
        {/* <VirtualBackground /> */}
        {/* <NoiseSuppression /> */}
        {/* {FeatureFlags.enableTranscription && <TranscriptionButton />} */}
        <Flex
          align="center"
          css={{
            display: 'none',
            '@md': {
              display: 'flex',
            },
          }}>
          {/* <VerticalDivider space={4} /> */}
          {/* <MetaActions isMobile /> */}
        </Flex>
      </Flex>
      {!isMobile && <Flex align="center" justify="center" css={{w: '100%'}}>
        <AudioVideoToggle showText={true}/>
        <ScreenshareToggle css={{mx: '$4'}} />
        <MoreSettings meetingUrl={meetingUrl} />
        <VerticalDivider style={{marginLeft:20}} space={4} />
        <MetaActions/>
        <LeaveRoom/>
        {false && (
          <Flex
            align="center"
            css={{display: 'none', '@md': {display: 'flex', ml: '$4'}}}>
            <Chat />
          </Flex>
        )}
      </Flex>}
      {isMobile && <Flex justify={'between'}  css={{w: '100%',marginBottom:fullScreen ? 40 : 90}}>
        <Flex>
          <AudioVideoToggle showText={true}/>
          <div style={{marginLeft:8}}>
            <MoreSettings switchFullScreen={switchFullScreen} meetingUrl={meetingUrl} isMobile={isMobile}/>
          </div>
        </Flex>
        <LeaveRoom/>
        {false && (
          <Flex
            align="center"
            css={{display: 'none', '@md': {display: 'flex', ml: '$4'}}}>
            <Chat />
          </Flex>
        )}
      </Flex>}

      {/* <Flex
        align="center"
        css={{
          position: 'absolute',
          right: '$7',
          '@md': {
            display: 'none',
          },
        }}>
        <MetaActions />
        <VerticalDivider space={4} />

        {false && <Chat />}
      </Flex> */}
    </Flex>
  );
};

const LeftDivider = () => {
  const allowedToPublish = useHMSStore(selectIsAllowedToPublish);
  return (
    <>
      {allowedToPublish.screen || FeatureFlags.enableWhiteboard ? (
        <VerticalDivider space={4} />
      ) : null}
    </>
  );
};
